import { Link } from '@tanstack/react-router'

import { StatusPage } from '@/components/StatusPage'
import { Button } from '@/components/ui/button'

/**
 * `defaultNotFoundComponent` on the router (see `src/router.tsx`) — rendered
 * for any URL that doesn't match a route, and for routes that explicitly
 * throw `notFound()`.
 */
export default function NotFound() {
  return (
    <StatusPage code={404} title="This page doesn't exist.">
      <Button asChild size="lg">
        <Link to="/">Go home</Link>
      </Button>
      <Button asChild size="lg" variant="outline">
        <Link to="/dashboard">Open dashboard</Link>
      </Button>
    </StatusPage>
  )
}
